<template>
    <div class="animated fadeIn">
        <spinner v-if="loading"/>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Search Back Orders</strong>
                    </div>
                    <b-row>
                        <b-col sm="3">
                            <b-form-group>
                                <label for="country_id">Country</label>
                                    <countryLookup v-bind:url="apiCountryLookup" v-on:selected="setCountry($event)" :lookupId="filter.country_id"/>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <label for="country_id">Location</label>
                            <warehouseLookup v-bind:url="apiWarehouseLookup" v-on:selected="setWarehouse($event)" :lookupId="filter.location_id" :q2="filter.country_id"/>
                        </b-col>
                        <b-col sm="3">
                            <label>Back Order No</label>
                            <b-form-group>
                                <b-form-input type="text" v-model="filter.back_order_num"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <label>Transaction Date</label>
                                <b-form-input type="date" v-model="filter.transaction_date"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div slot="footer">
                        <b-button type="submit" size="lg" variant="primary" @click="search">Search</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="searchResults.length >0 && !loading">
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Back Orders</strong>
                    </div>
                    <b-row>
                        <b-col sm="12">
                            <div class="table-responsive">
                                <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :items="searchResults"
                                :per-page="perPage" :current-page="currentPage"></b-table>
                            </div>
                            <nav>
                                <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                            </nav>
                        </b-col>
                    </b-row>
                    <div slot="footer">
                        <exportExcel class   = "btn btn-primary btn-lg" size ="lg" :data = "searchResults" :fields = "exportHeaders" name = "back_orders.xls">
                            Export to Excel
                        </exportExcel>
                        &nbsp;&nbsp;
                        <b-button type="submit" size="lg" variant="success" @click="print">Print</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-else-if="noResults && !loading" >
                <b-col sm="12">
                  <div align="center">
                    <strong>No Records Found</strong>
                  </div>                    
                </b-col>
        </b-row>
    </div>
</template>
<script>
import axios from 'axios'
import spinner from '@/components/Spinner.vue'
import countryLookup from '@/components/Autocomplete.vue'
import warehouseLookup from '@/components/Autocomplete.vue'
import {authHeader, apiCountryLookup,apiWarehouseLookup,apiPodUpdate,apiPodSearch,apiBackOrdersSearch} from '@/functions/common.vue'

 import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  pdfMake.fonts = {
      "ukai": {
         normal: 'ukai.ttf',
          bold: 'ukai.ttf',
          italics: 'ukai.ttf',
           bolditalics: 'ukai.ttf'
      },
   };

import exportExcel from 'vue-json-excel'

export default
{
    components:{spinner,countryLookup,warehouseLookup,exportExcel},
    props: 
    {
      caption: 
      {
        type: String,
        default: 'Table'
      },
      hover: 
      {
        type: Boolean,
        default: false
      },
      striped: 
      {
        type: Boolean,
        default: false
      },
      bordered: 
      {
        type: Boolean,
        default: false
      },
      small: 
      {
        type: Boolean,
        default: false
      },
      fixed: 
      {
        type: Boolean,
        default: false
      }
    },
    data()
    {
        return{
            loading:false,
            apiCountryLookup:apiCountryLookup,
            apiWarehouseLookup:apiWarehouseLookup,
            filter: 
            {
                country_id: '',
                location_id:'',
                back_order_num:'',
                transaction_date: '',
                sales_doc_num:'',
                invoice_date:'',
            },  
            exportHeaders:
            {
              'Country': 'country_id',
              'Location': 'location_id',
              'Trans Date': 'transaction_date',
              'Invoice Date':'invoice_date',
              'Invoice #':'invoice_number',
              'Member':'member_name',
              'SKU':'product_code',
              'Description':'product_name',
              'BackOrder Qty':'back_order_qty',
              'Delivery Method':'delivery_method_name',
              'Remarks':'remarks'
            }, 
            searchResults: [],
            searchResultsFields: 
            [
                {key: 'country_id', label: 'Country'},
                {key: 'location_id', label: 'Warehouse'},
                {key: 'transaction_date', label: 'Trans Date'},
                {key: 'invoice_date', label: 'Invoice Date'},
                {key: 'invoice_number', label: 'Invoice #'},
                {key: 'member_name', label: 'Customer Name'},
                {key: 'product_code', label: 'SKU'},
                {key: 'product_name', label: 'Description'},
                {key: 'back_order_qty', label: 'BackOrder Qty'},
                {key: 'delivery_method_name', label: 'Delivery Method'},
                {key: 'remarks', label: 'Remarks'}
            ],
            currentPage: 1,
            perPage: 30,
            totalRows: 0,
            noResults: false
            }
    },
    methods:
    {
        print()
        {
          var rows = []
          var row = []
          var date = new Date()
          rows.push([
          'Country',
          'Location',
          'Trans Date',
          'Invoice #',
          'Invoice Date',
          'Member Name',
          'SKU',
          'Description',
          'Back Order Qty',
          'Delivery Method',
          'Remarks'
          ])

          for (let key in this.searchResults)
          {
            var data = this.searchResults[key]
            row = [data.country_id,data.location_id,data.transaction_date,data.invoice_number,data.invoice_date,data.member_name,data.product_code,data.product_name,data.back_order_qty,data.delivery_method_name,data.remarks]
            rows.push(row)
          }
          var dd = {
            header:{ text: 'Back Order Report generated on'+ " "+ date, margin: [ 5, 7, 10, 30 ],alignment: 'center',fontSize:7 },
            pageSize: 'A4',
            pageOrientation: 'landscape',
          
            // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
            pageMargins: [30, 20, 30, 20 ],
            defaultStyle: {
            font: 'ukai'
          },
            content: [
              {
                fontSize: 8,
                layout: 'lightHorizontalLines', // optional
                table: {
                  // headers are automatically repeated if the table spans over multiple pages
                  // you can declare how many rows should be treated as headers
                  headerRows: 1,
                  widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto','auto','auto','auto','auto' ],
                  body: 
                    rows
                  
                }
              }
            ]
          };

          pdfMake.createPdf(dd).open();
        },
        search()
        {

            var sf =
            [
              "country_id = " + this.filter.country_id
              ,"location_id = " + this.filter.location_id
              ,"back_order_num LIKE " + this.filter.back_order_num
              ,"transaction_date = " + this.filter.transaction_date
            ]

                this.loading = true
                axios.post(apiBackOrdersSearch, sf,authHeader())
                .then (res => 
                {
                    return res
                })
                .then (data =>
                {
                    this.loading = false
                    
                    var items = data.data.data
                    var result = ''

                    for(var d in items)
                    {
                        var date = items[d].invoice_date
                        
                        if(date != null && date != '-')
                        {
                            var date = new Date(date);
                            result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                        }
                        else
                        {
                            result = "-"
                        }

                        var transaction_date = items[d].transaction_date
                        if(transaction_date != null)
                        {
                            transaction_date = new Date(transaction_date);
                            transaction_date = "" + (transaction_date.getDate() > 9 ? '' : '0') + transaction_date.getDate() + '/'+  ((transaction_date.getMonth() + 1) > 9 ? '' : '0') + (transaction_date.getMonth() + 1) + '/' + transaction_date.getFullYear()
                        }
                        else
                        {
                            transaction_date = "-"
                        }
                        
                        items[d].transaction_date = transaction_date
                        items[d].invoice_date = result
                    }

                    this.searchResults = items
                    if(this.searchResults.length == 0)
                    {
                        this.noResults = true
                        this.loading = false
                    }
                        
                })
                .catch(error => alert(error))
        },
        setCountry(obj)
        {
            var id

                if (obj !== null)
                {
                    id = obj.id
                } 
                else
                {
                    id = ""
                }
            this.filter.country_id = id
        },
        setWarehouse(obj)
        {
            var id

                if (obj !== null)
                {
                    id = obj.id
                } 
                else
                {
                    id = ""
                }
            this.filter.location_id = id
        },
        getRowCount (items) 
        {
            return items.length
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/reports/bor.vue